// Authorization endpoint
export const SEND_OTP = '/authorization/send-otp';
export const AUTHENTICATE = '/authorization/v3/authenticate';
export const OAUTH_DETAIL_V2 = '/authorization/v2/oauth-details';
export const OAUTH_DETAIL_V3 = '/authorization/v3/oauth-details';
export const PAR_OAUTH_DETAIL = '/authorization/par-oauth-details';
export const AUTHCODE = '/authorization/auth-code';
export const CSRF = '/csrf/token';
export const CLAIM_DETAILS = '/authorization/claim-details';
export const PREPARE_SIGNUP_REDIRECT = '/authorization/prepare-signup-redirect';
export const RESUME = '/authorization/complete-signup-redirect';

// Link authorization endpoint
export const LINK_CODE_GENERATE = '/linked-authorization/link-code';
export const LINK_STATUS = '/linked-authorization/link-status';
export const LINK_AUTHORIZATION_CODE = '/linked-authorization/link-auth-code';

// SBI endpoint
export const DEVICE = '/device';
export const INFO = '/info';
export const CAPTURE = '/capture';

// Route endpoint
export const SOMETHING_WENT_WRONG = '/something-went-wrong';
export const PAGE_NOT_FOUND = '/page-not-found';
export const LOGIN = '/login';
export const AUTHORIZE = '/authorize';
export const CONSENT = '/consent';
export const ESIGNET_DETAIL = '/';
export const CLAIM_DETAIL = '/claim-details';
export const NETWORK_ERROR = '/network-error';
